import { useContext } from "react";
import { EventContext, EventContextType } from "../provider/EventProvider";

export default function EventCategories() {
  const { categories, filters, categorySetter } = useContext(EventContext) as EventContextType;

  return (
    <div className="categories">
			<div className="title"><h6>Categories</h6></div>
			<ul className="list">
        { categories.length > 0 && categories.map((item, index) => {
            return (
              <li key={`category-${index}`} className={filters.category === item ? 'active' : ''}>
                <a href="#" onClick={() => categorySetter(item)}>{item}</a>
            </li>
            )
          })
        }
			</ul>
		</div>
  )
}